export const NavClosed = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.4697 6.46991C6.76259 6.17702 7.23747 6.17702 7.53036 6.46991L14 12.9396L20.4697 6.46991C20.7626 6.17702 21.2375 6.17702 21.5304 6.46991C21.8233 6.76281 21.8233 7.23768 21.5304 7.53057L15.0607 14.0002L21.5304 20.4699C21.8233 20.7628 21.8233 21.2377 21.5304 21.5306C21.2375 21.8235 20.7626 21.8235 20.4697 21.5306L14 15.0609L7.53036 21.5306C7.23747 21.8235 6.76259 21.8235 6.4697 21.5306C6.17681 21.2377 6.17681 20.7628 6.4697 20.4699L12.9394 14.0002L6.4697 7.53057C6.17681 7.23768 6.17681 6.76281 6.4697 6.46991Z"
        fill="#8F918D"
      />
    </svg>
  );
};
